// extracted by mini-css-extract-plugin
export default {"boxForm":"BoxForm_boxForm__4CdrK","request":"BoxForm_request__j4Ad-","customButton":"BoxForm_customButton__QjkWr"};